import { Button, TextArea } from '@protoss/ui';
import * as React from 'react';
import { pastedTextToFile } from '../lib/dealDocumentUpload';

/**
 * "Paste text" option next to a deal-document dropzone, for someone who only has an email body or a
 * few lines. The text is wrapped into a File named `pasted-text.txt` and handed to `onAdd`, which
 * runs it through the normal upload - no separate server path.
 */
export function DealDocumentPasteBox({
  disabled,
  existingNames,
  onAdd,
}: {
  disabled: boolean;
  existingNames: readonly string[];
  onAdd: (file: File) => void;
}) {
  const [open, setOpen] = React.useState(false);
  const [text, setText] = React.useState('');

  if (!open) {
    return (
      <div className="customer-doc-add-panel__paste">
        <button
          type="button"
          className="customer-doc-add-panel__paste-toggle"
          disabled={disabled}
          onClick={() => setOpen(true)}
        >
          Paste text instead
        </button>
      </div>
    );
  }

  const close = () => {
    setOpen(false);
    setText('');
  };

  return (
    <div className="customer-doc-add-panel__paste customer-doc-add-panel__paste--open">
      <TextArea
        label="Paste text"
        rows={8}
        value={text}
        disabled={disabled}
        placeholder="Paste an email, notes or any client text"
        onChange={(e) => setText(e.target.value)}
      />
      <div className="customer-doc-add-panel__paste-actions">
        <Button type="button" variant="ghost" size="sm" disabled={disabled} onClick={close}>
          Cancel
        </Button>
        <Button
          type="button"
          variant="primary"
          size="sm"
          disabled={disabled || text.trim() === ''}
          onClick={() => {
            onAdd(pastedTextToFile(text, existingNames));
            close();
          }}
        >
          Add text
        </Button>
      </div>
    </div>
  );
}
